import {Component, forwardRef, ChangeDetectorRef, Injector} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { CameraModel } from '../camera.model';
import { PlatformService } from 'src/app/core-api/platform/platform.service';

@Component({
    selector: 'abw-camera-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CameraFormComponent),
        multi: true
      }
    ],
    templateUrl: './camera-form.component.html',
    styleUrls: ['./camera-form.component.scss']
})
export class CameraFormComponent extends AbstractWorkflowFormComponent<CameraModel, string> {
    constructor(
      private platformService: PlatformService,
      _workflowComponentsService: WorkflowComponentsService,
      _cdf: ChangeDetectorRef,
      _injector: Injector
	) {
        super(_workflowComponentsService, _cdf, _injector);
    }

    async takePhoto() {
      try {
        const result = await this.platformService.takePhoto();
        this.onValueChanged(result);
      } catch(e) {
        console.error(e);
      }
    }
}